import { observer } from "mobx-react-lite";
import * as React from "react";
import { createPortal } from "react-dom";
import styled, { css } from "styled-components";
import { MediaQueries } from "src/constants";
import { Toast } from "./Toast.component";
import { useToastStore } from "./Toast.store";
import { isIFrame } from "src/helpers";

const ToastPortalEl = styled.div`
  position: fixed;
  width: 100vw;
  z-index: ${(p) => p.theme.layout.zIndex.toast};

  ${!isIFrame() &&
  css`
    ${MediaQueries.screen.medium.maxWidth} {
      bottom: 0;
    }
  `}
`;

const ToastWrapperEl = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 44px;
  top: 44px;
  width: 320px;

  ${isIFrame() &&
  css`
    ${MediaQueries.screen.medium.maxWidth} {
      left: 16px;
      max-width: calc(100vw - 32px);
      right: 16px;
      top: 16px;
    }
  `}

  ${!isIFrame() &&
  css`
    ${MediaQueries.screen.medium.maxWidth} {
      bottom: 16px;
      flex-direction: column-reverse;
      left: 16px;
      right: 16px;
      top: auto;
      width: auto;
    }
  `}
`;

export const ToastManager = observer((_) => {
  const { $toastItems, closeById } = useToastStore();

  return createPortal(
    <ToastPortalEl>
      <ToastWrapperEl>
        {$toastItems.map((toastItem, key) => (
          <Toast key={key} toastItem={toastItem} onClose={closeById} />
        ))}
      </ToastWrapperEl>
    </ToastPortalEl>,
    document.getElementById("root")!
  );
});
